<template>
  <div class="apb-Wrapper">
    <AppBannerExtended
      :data-auto-testid="CHECKINS_SETTINGS_BANNER_TEST_ID"
      :data-testid="CHECKINS_SETTINGS_BANNER_TEST_ID"
      :type="APP_BANNER_EXTENDED_TYPES.HORIZONTAL"
      @close="dismissCheckInsBanner"
    >
      <template #title>
        {{ t('checkins.banner.title') }}
      </template>
      <template #description>
        <i18n-t keypath="checkins.banner.description" scope="global">
          <template #break>
            <br />
          </template>
        </i18n-t>
      </template>
      <template #left-actions>
        <AppHrefLink :href="CHECKINS_GUIDE_LINK" class="apb-LearnMoreLink">
          <div class="apb-LearnMoreLink-LinkText">
            <span>{{ t('action.learn_more') }}</span>
            <AppIcon height="20" icon-name="arrow-right-next" width="20" />
          </div>
        </AppHrefLink>
      </template>
      <template #right-content>
        <div class="apb-RightContent_Container">
          <AppHrefLink :href="CHECKINS_TUTORIAL_LINK" class="apb-RightContent_Button">
            <div class="apb-LinkText">
              <span>{{ t('action.watch_tutorial') }}</span>
              <AppIcon height="20" icon-name="play-next" width="20" />
            </div>
          </AppHrefLink>
        </div>
      </template>
    </AppBannerExtended>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

import { APP_BANNER_EXTENDED_TYPES } from '@/utils/components-configurations/app-banner-extended'
import { CHECKINS_GUIDE_LINK, CHECKINS_TUTORIAL_LINK } from '@/utils/links'
import { IS_SHOW_BANNER_ON_AUTOMATIONS_PAGE, USER_SETTINGS_MAPPER } from '@/utils/user-settings'

import AppBannerExtended from '@/components/AppBannerExtended'
import AppHrefLink from '@/components/AppHrefLink'
import { CHECKINS_SETTINGS_BANNER_TEST_ID } from '@/components/check-ins/jest-helpers'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'AutomationsPageBanner'
})

const store = useStore()
const { t } = useI18n()

const dismissCheckInsBanner = () => {
  store.dispatch('system/updateUserSettings', {
    [USER_SETTINGS_MAPPER[IS_SHOW_BANNER_ON_AUTOMATIONS_PAGE]]: false
  })
}
</script>

<style lang="scss" scoped>
.apb-Wrapper {
  width: 100%;
  max-width: var(--ob-automations-page-width);
  padding: 0 $page-right-padding 0 $page-left-padding;
}

.apb-RightContent_Container {
  display: flex;
  align-items: center;
  justify-content: center;

  background-image: image-set(
    url('~@/assets/images/checkins-automations-banner@1x.jpg') 1x,
    url('~@/assets/images/checkins-automations-banner@2x.jpg') 2x,
    url('~@/assets/images/checkins-automations-banner@3x.jpg') 3x,
    url('~@/assets/images/checkins-automations-banner@4x.jpg') 4x
  );
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  width: 250px;
  height: 141px;
  flex-direction: column;
  border: 1px solid $white;
  border-radius: $border-radius-sm-next;
  box-shadow: 0 2px 7px 0 rgba($black, 0.1), 0 7px 10px 0 rgba($black, 0.06);
}

.apb-RightContent_Button {
  background-color: $white;
  color: $primary-color-next;
  padding: 6px 4px 6px 8px;
  border-radius: $border-radius-sm-next;
  text-decoration: none;
  font-size: $fs-14;
  font-weight: fw('semi-bold');
  transition: $transition-fast;

  &:hover {
    background-color: var(--gray-blue-100);
  }
  &:active {
    background-color: $white;
  }
}

.apb-LinkText {
  display: flex;
  align-items: center;
  gap: 4px;
}

.apb-LearnMoreLink {
  text-decoration: none;
  color: $white;
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
}

.apb-LearnMoreLink-LinkText {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
